// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assests//stacking-cards.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assests/background-image/dao-page_voting.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assests/background-image/stakingMachines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assests/background-image/executionOfApproveBg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assests/background-image/dao_unclock_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dao-container {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
}

.dao-section-title {
  font-size: 50px;
  font-weight: 700;
  text-align: center;
}

.dao-section-para {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #515151;
}

.daoImg {
  width: 80%;
}

.magnum-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: -moz-fit-content;
  height: fit-content;
}

.magnum-cards {
  width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  gap: 0.5rem;
  padding: 20px;
  border-radius: 20px;
}

.magnum-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.magnum-cards p {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #515151;
}

.magnum-cards h4 {
  font-size: 30px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
}

.proposals-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.proposals-wrapper p {
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  color: #515151;
  text-align: center;
}

.voting-cards {
  width: 23rem;
  display: flex;
  gap: 1rem;
  padding: 30px;
}

.voting-cards h4 {
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
}

.voting-cards_brd_btm {
  border-bottom: 1px solid #6f6c6c !important;
}

.voting-cards_brd_rht {
  border-right: 1px solid #6f6c6c;
}

.voting-prop-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 22rem;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0 10px;
  flex-grow: 1;
}

.voting-card-brder {
  border-right: 1px dotted #7c7c7c;
}

.voting-prop-card h3 {
  font-size: 30px;
  font-weight: 600;
  white-space: nowrap;
  margin: 0;
}

.voting-prop-card p {
  font-size: 16px;
  line-height: normal;
  font-weight: 400;
  color: #515151;
  letter-spacing: 0.4px;
}

.staking-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5rem;
}

.staking-cards-con {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5rem;
}

.hrefReadMore{
  text-decoration: none;
}

.staking-cards {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  width: 29rem;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 26px;
  box-shadow: 2px 2px 10px 0 #0000003d;
  border-radius: 20px;
}

.staking-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.staking-img {
  right: 0;
  top: -50px;
}

.staking-cards h3 {
  font-size: 30px;
  font-weight: 600;
  /* line-height: 30px; */
}

.staking-cards p {
  font-size: 20px;
  font-weight: 500;
  /* letter-spacing: 0.4px; */
  color: #515151;
}

.exe-cards-conatain {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.exe-cards {
  box-shadow: 0 0 10px 0 #00000033;
  width: 90%;
  padding: 25px 55px;
  display: flex;
  align-self: flex-end;
  gap: 1rem;
}

.exe-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.exe-img {
  left: -97px;
  top: 17px;
}

.exe-cards h4 {
  font-size: 30px;
  font-weight: 600;
  line-height: 45px;
}

.exe-cards p {
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
}

.bottomDao-left {
  height: 28rem;
  width: 10rem;
  position: absolute;
  z-index: -1;
  top: 180rem;
  /* right: 0; */
  left: 0;
  /* background: linear-gradient(164deg, rgb(232, 68, 39), rgb(35 75 153)); */
  background: linear-gradient(
    164deg,
    rgb(232 68 39 / 55%),
    rgb(35 75 153 / 45%)
  );
  filter: blur(130px);
}

.eco-card-cntxxx {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #337ab7;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
}

/* .voting-cards{
    word-break: break-all;
} */

@media screen and (max-width: 1200px) {
    .voting-cards_brd_rht {
      border-right: none !important;
    }
  
    .voting-cards_brd_btm {
      border-right: none !important;
    }
  
    .voting-card-brder {
      border: none;
    }
    .voting-cards{
      border-bottom: 1px solid #6f6c6c;
    }
  }

@media screen and (max-width: 990px) {
  .daoImg {
    width: 100%;
  }
  .voting-cards_brd_rht{
    border-bottom: 1px solid #6f6c6c;
  }
  .voting-cards{
    border-bottom: 1px solid #6f6c6c;
    padding: 24px 0px;
    margin: 0px 30px;
  }
  .voting-cards h4{
    font-size: 20px;
    /* word-break: auto-phrase; */

  }
}

@media screen and (max-width: 740px) {
    .voting-cards {
      width: 100%;
      border-right: none !important;
    }
  }
  @media screen and (max-width: 600px) {
    .staking-cards {
      width: 95%;
    }
  
    .magnum-cards {
      width: 95%;
    }
    .sndks{
      margin: 0 auto;
    }
    .dao-section-title {
      font-size: 32px;
      line-height: normal;
      font-weight: 700;
      text-align: center;
    }
  
    .staking-img {
      right: 0;
      top: -72px;
    }
  
    .proposals-wrapper p {
      width: 90%;
      font-size: 16px;
    }
  
    .voting-prop-card {
      width: 90%;
      border-bottom: 0.3px solid #6f6c6c;
    }
    .exe-img img{
      width: 100px;
    }
  
    .exe-img {
      left: -45px;
    }
  }

  @media screen and (max-width:570px) {
    .rpsvdoabtn{
        width: 205px !important;
    }
    .magnum-cards h4{
        font-size: 20px;
    }
    .eco-card-cntxxx{
        width: 30px;
        height: 30px;
        font-size: 16px;
    }
    .voting-prop-card h3{
        font-size: 20px;
    }
    .staking-img{
        width: 56px;
        top: -36px;
    }
    .staking-cards h3{
        font-size: 20px;
    }
    .staking-cards p{
        font-size: 16px;
    }
    .exe-cards h4{
        font-size: 20px;
        font-weight: 700;
        line-height: normal;
    }
    .exe-cards p{
        font-size: 16px;
        line-height: normal;
    }

    .voting_res_bg{
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
      background-repeat: no-repeat;
      background-size: cover;
      padding: 1rem 0rem 1rem 0rem;
    }
    .staking-section{
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
      background-size: cover;
      background-repeat: no-repeat;
    }
    .exe_prps{
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
      background-size: cover;
      background-repeat: no-repeat;
    }
    .dao_unlock_home{
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-size: contain;
      background-repeat: no-repeat;
    }
    /* .dao-container{
      gap: 0;
      padding: 0;
    }
    .dao-container > div{
      padding-bottom: 3.5rem;
      padding: 0px 10px;
    } */
  }

`, "",{"version":3,"sources":["webpack://./src/pages/DAO/Dao.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,wBAAmB;EAAnB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mDAAoD;EACpD,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,OAAO;EACP,2EAA2E;EAC3E;;;;GAIC;EACD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;IACI;MACE,6BAA6B;IAC/B;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,YAAY;IACd;IACA;MACE,gCAAgC;IAClC;EACF;;AAEF;EACE;IACE,WAAW;EACb;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,6BAA6B;;EAE/B;AACF;;AAEA;IACI;MACE,WAAW;MACX,6BAA6B;IAC/B;EACF;EACA;IACE;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;IACA;MACE,cAAc;IAChB;IACA;MACE,eAAe;MACf,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,UAAU;MACV,kCAAkC;IACpC;IACA;MACE,YAAY;IACd;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE;QACI,uBAAuB;IAC3B;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;MACE,yDAA2E;MAC3E,4BAA4B;MAC5B,sBAAsB;MACtB,4BAA4B;IAC9B;IACA;MACE,yDAA2E;MAC3E,sBAAsB;MACtB,4BAA4B;IAC9B;IACA;MACE,yDAAgF;MAChF,sBAAsB;MACtB,4BAA4B;IAC9B;IACA;MACE,yDAA0E;MAC1E,wBAAwB;MACxB,4BAA4B;IAC9B;IACA;;;;;;;OAOG;EACL","sourcesContent":[".dao-container {\n  display: flex;\n  flex-direction: column;\n  gap: 3.5rem;\n}\n\n.dao-section-title {\n  font-size: 50px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.dao-section-para {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  color: #515151;\n}\n\n.daoImg {\n  width: 80%;\n}\n\n.magnum-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  height: fit-content;\n}\n\n.magnum-cards {\n  width: 320px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 20px;\n  border-radius: 20px;\n}\n\n.magnum-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.magnum-cards p {\n  font-size: 16px;\n  font-weight: 400;\n  text-align: center;\n  color: #515151;\n}\n\n.magnum-cards h4 {\n  font-size: 30px;\n  text-align: center;\n  line-height: 40px;\n  font-weight: 600;\n}\n\n.proposals-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n}\n\n.proposals-wrapper p {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: normal;\n  color: #515151;\n  text-align: center;\n}\n\n.voting-cards {\n  width: 23rem;\n  display: flex;\n  gap: 1rem;\n  padding: 30px;\n}\n\n.voting-cards h4 {\n  font-size: 24px;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.voting-cards_brd_btm {\n  border-bottom: 1px solid #6f6c6c !important;\n}\n\n.voting-cards_brd_rht {\n  border-right: 1px solid #6f6c6c;\n}\n\n.voting-prop-card {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 22rem;\n  height: fit-content;\n  margin: 0 10px;\n  flex-grow: 1;\n}\n\n.voting-card-brder {\n  border-right: 1px dotted #7c7c7c;\n}\n\n.voting-prop-card h3 {\n  font-size: 30px;\n  font-weight: 600;\n  white-space: nowrap;\n  margin: 0;\n}\n\n.voting-prop-card p {\n  font-size: 16px;\n  line-height: normal;\n  font-weight: 400;\n  color: #515151;\n  letter-spacing: 0.4px;\n}\n\n.staking-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 5rem;\n}\n\n.staking-cards-con {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 5rem;\n}\n\n.hrefReadMore{\n  text-decoration: none;\n}\n\n.staking-cards {\n  background: url(\"../../assests//stacking-cards.png\");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 29rem;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.8rem;\n  padding: 26px;\n  box-shadow: 2px 2px 10px 0 #0000003d;\n  border-radius: 20px;\n}\n\n.staking-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.staking-img {\n  right: 0;\n  top: -50px;\n}\n\n.staking-cards h3 {\n  font-size: 30px;\n  font-weight: 600;\n  /* line-height: 30px; */\n}\n\n.staking-cards p {\n  font-size: 20px;\n  font-weight: 500;\n  /* letter-spacing: 0.4px; */\n  color: #515151;\n}\n\n.exe-cards-conatain {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.exe-cards {\n  box-shadow: 0 0 10px 0 #00000033;\n  width: 90%;\n  padding: 25px 55px;\n  display: flex;\n  align-self: flex-end;\n  gap: 1rem;\n}\n\n.exe-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.exe-img {\n  left: -97px;\n  top: 17px;\n}\n\n.exe-cards h4 {\n  font-size: 30px;\n  font-weight: 600;\n  line-height: 45px;\n}\n\n.exe-cards p {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 30px;\n}\n\n.bottomDao-left {\n  height: 28rem;\n  width: 10rem;\n  position: absolute;\n  z-index: -1;\n  top: 180rem;\n  /* right: 0; */\n  left: 0;\n  /* background: linear-gradient(164deg, rgb(232, 68, 39), rgb(35 75 153)); */\n  background: linear-gradient(\n    164deg,\n    rgb(232 68 39 / 55%),\n    rgb(35 75 153 / 45%)\n  );\n  filter: blur(130px);\n}\n\n.eco-card-cntxxx {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #337ab7;\n  color: #fff;\n  font-size: 36px;\n  font-weight: 600;\n}\n\n/* .voting-cards{\n    word-break: break-all;\n} */\n\n@media screen and (max-width: 1200px) {\n    .voting-cards_brd_rht {\n      border-right: none !important;\n    }\n  \n    .voting-cards_brd_btm {\n      border-right: none !important;\n    }\n  \n    .voting-card-brder {\n      border: none;\n    }\n    .voting-cards{\n      border-bottom: 1px solid #6f6c6c;\n    }\n  }\n\n@media screen and (max-width: 990px) {\n  .daoImg {\n    width: 100%;\n  }\n  .voting-cards_brd_rht{\n    border-bottom: 1px solid #6f6c6c;\n  }\n  .voting-cards{\n    border-bottom: 1px solid #6f6c6c;\n    padding: 24px 0px;\n    margin: 0px 30px;\n  }\n  .voting-cards h4{\n    font-size: 20px;\n    /* word-break: auto-phrase; */\n\n  }\n}\n\n@media screen and (max-width: 740px) {\n    .voting-cards {\n      width: 100%;\n      border-right: none !important;\n    }\n  }\n  @media screen and (max-width: 600px) {\n    .staking-cards {\n      width: 95%;\n    }\n  \n    .magnum-cards {\n      width: 95%;\n    }\n    .sndks{\n      margin: 0 auto;\n    }\n    .dao-section-title {\n      font-size: 32px;\n      line-height: normal;\n      font-weight: 700;\n      text-align: center;\n    }\n  \n    .staking-img {\n      right: 0;\n      top: -72px;\n    }\n  \n    .proposals-wrapper p {\n      width: 90%;\n      font-size: 16px;\n    }\n  \n    .voting-prop-card {\n      width: 90%;\n      border-bottom: 0.3px solid #6f6c6c;\n    }\n    .exe-img img{\n      width: 100px;\n    }\n  \n    .exe-img {\n      left: -45px;\n    }\n  }\n\n  @media screen and (max-width:570px) {\n    .rpsvdoabtn{\n        width: 205px !important;\n    }\n    .magnum-cards h4{\n        font-size: 20px;\n    }\n    .eco-card-cntxxx{\n        width: 30px;\n        height: 30px;\n        font-size: 16px;\n    }\n    .voting-prop-card h3{\n        font-size: 20px;\n    }\n    .staking-img{\n        width: 56px;\n        top: -36px;\n    }\n    .staking-cards h3{\n        font-size: 20px;\n    }\n    .staking-cards p{\n        font-size: 16px;\n    }\n    .exe-cards h4{\n        font-size: 20px;\n        font-weight: 700;\n        line-height: normal;\n    }\n    .exe-cards p{\n        font-size: 16px;\n        line-height: normal;\n    }\n\n    .voting_res_bg{\n      background-image: url('../../assests/background-image/dao-page_voting.png');\n      background-repeat: no-repeat;\n      background-size: cover;\n      padding: 1rem 0rem 1rem 0rem;\n    }\n    .staking-section{\n      background-image: url('../../assests/background-image/stakingMachines.png');\n      background-size: cover;\n      background-repeat: no-repeat;\n    }\n    .exe_prps{\n      background-image: url('../../assests/background-image/executionOfApproveBg.png');\n      background-size: cover;\n      background-repeat: no-repeat;\n    }\n    .dao_unlock_home{\n      background-image: url('../../assests/background-image/dao_unclock_bg.png');\n      background-size: contain;\n      background-repeat: no-repeat;\n    }\n    /* .dao-container{\n      gap: 0;\n      padding: 0;\n    }\n    .dao-container > div{\n      padding-bottom: 3.5rem;\n      padding: 0px 10px;\n    } */\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
